// M3 offshore operations: daily ticks. tickM3Weather runs before drilling (today's sea state gates today's work);
// tickM3Ops runs after production (platforms, logistics, charters, EOR, megaprojects, offshore milestones).
// Both are no-ops before 1946, so M1/M2 games never create M3 state.
import { allWells } from '../indexes.js'; // perf: per-day well list (same order as Object.values)
import { yearOf, fieldDef } from '../defs.js';
import { m3On } from './opsutil.js';
import { tickStorms } from './storms.js';
import { tickPlatforms } from './platforms.js';
import { tickLogistics } from './logistics.js';
import { tickCharters, tickCharterOut } from './charters.js';
import { tickEor } from './eor.js';
import { tickMegaprojects } from './megaprojects.js';
import { notify } from '../util.js';
import { dayToDate } from '../../core/time.js';

export function tickM3Weather(state) {
  if (!m3On(state)) return;
  tickStorms(state);
}

export function tickM3Ops(state) {
  if (!m3On(state)) return;
  tickPlatforms(state);
  tickLogistics(state);
  tickCharters(state);
  tickCharterOut(state);
  tickEor(state);
  tickMegaprojects(state);
  milestones(state);
}

function milestones(state) {
  const st = state.company.stats;
  for (const w of allWells(state)) {
    if (w.status !== 'PRODUCING' || w.firstProdYear) continue;
    w.firstProdYear = w.prod?.startDay != null ? dayToDate(w.prod.startDay).year : yearOf(state);
    if (!w.offshore || w.ownerOperatorId) continue;
    st.offshoreWells = (st.offshoreWells ?? 0) + 1;
    if (st.offshoreWells === 1) {
      st.firstOffshoreDay = state.day;
      notify(state, 'news', { kind: 'offshore', press: 'firstOffshore', wellId: w.id, fieldId: w.fieldId, pause: true, level: 'major',
        text: `${w.name} is flowing from ${w.waterDepthFt} ft of water at ${fieldDef(w.fieldId)?.name} — your first offshore producer.` });
    }
  }
}
